import { render, staticRenderFns } from "./FormInputList.vue?vue&type=template&id=2c352488&scoped=true"
import script from "./FormInputList.vue?vue&type=script&lang=js"
export * from "./FormInputList.vue?vue&type=script&lang=js"
import style0 from "./FormInputList.vue?vue&type=style&index=0&id=2c352488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c352488",
  null
  
)

export default component.exports